export const endpoints = {
  searchMessages: 'message/search',
  message: 'message',
  languageOptions: 'message/language/options'
};
